
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
Radio,
Group,
XButton,
Flexbox,
FlexboxItem,
Confirm,
Toast
},
data() {
return {
show: false,
show1: false,
showPositionValue:false,
title: "目录",
CollCourse:[],
CollVideo:[],
}
},
mounted(){
var hrefUrl = location.host;
hrefUrl = "http://softtone.jqweike.com/login?callback=" + encodeURIComponent(hrefUrl);
document.getElementById("a").href = hrefUrl;
if (localStorage.getItem("userName") != "" && localStorage.getItem("userName") != null && localStorage.getItem(
"userName") != undefined) {
document.getElementById("is_login").style.display = "block";
document.getElementById("no_login").style.display = "none";
} else {
document.getElementById("no_login").style.display = "block";
document.getElementById("is_login").style.display = "none";
}
this.GetCatalog();

},
methods: {

onConfirm(value){
if(value != "" && value != null && value != undefined){
this.$api.AddCollectGroupList("vid",value)
.then((data) => {
if(data.data.Status ==0 ){
this.GetCatalog();
}
})
}else{
this.showPositionValue = true;
}

},

onConfirm1(value){
if(value != "" && value != null && value != undefined){
this.$api.AddCollectGroupList("crs",value)
.then((data) => {
if(data.data.Status ==0 ){
this.GetCatalog();
}
})
}else{
this.showPositionValue = true;
}
},

GetCatalog:function(){
this.$api.CollectCatalog("crs")
.then((data)  => {
if(data.data.Status != 0){
return ;
}
this.CollCourse=[];
this.CollCourse = data.data.Data.rows;
})

this.$api.CollectCatalog("vid")
.then((data)  => {
if(data.data.Status != 0){
return ;
}
this.CollVideo=[];
this.CollVideo = data.data.Data.rows;
})
},

AddCollect:function() {
var ChapterID = this.GLOBAL.ChapterID;
var IDCode = this.GLOBAL.IDCode;

var radios=document.getElementsByName("demo-radio");

var selectvalue=null;   
for(var i=0;i<radios.length;i++){
if(radios[i].checked==true) {
selectvalue=radios[i].value;
break;
}
}

if(selectvalue=="收藏本视频"){
var obj = document.getElementById("one"); 
var index = obj.selectedIndex; 
var value = obj.options[index].value; 

if(ChapterID == undefined || ChapterID == "" || ChapterID == null ||
IDCode == undefined || IDCode == "" || IDCode == null){
alert("错误，未正确获取课程或视频");
}else{
this.$tyh.GetByChapterID(ChapterID)
.then((data) => {
if(data.data.Status != 0){
return ;
}
var ContextID = data.data.Data.resource.ID;
for(var i in this.CollVideo){
if(this.CollVideo[i].Name== value){
var addBody ={
FavTypeNo: "vid",
CategoryID: this.CollVideo[i].ID,
ContextID:ContextID
}

this.$api.addConllect(addBody)
.then((data) => {

if(data.data.Status == 0){

alert("收藏成功")

this.AddLog("StoreVideo");

this.$api.SetScore("CollectionScore")
.then((data) => {
if(data.data.Status == 1){

}
})
}else{
if(data.data.Data == "已收藏"){
alert("已在收藏中")
}
}
})
}
}
})


}
}

if(selectvalue=="收藏本课程"){

var obj = document.getElementById("two"); 
var index = obj.selectedIndex; 
var value = obj.options[index].value; 

if(IDCode == undefined || IDCode == "" || IDCode == null){
alert("错误，未正确获取课程");
}else{

for(var i in this.CollCourse){
if(this.CollCourse[i].Name== value){
var addBody ={
FavTypeNo: "crs",
CategoryID: this.CollCourse[i].ID,
ContextID:IDCode
}

this.$api.addConllect(addBody)
.then((data) => {
if(data.data.Status == 0){
alert("收藏成功");

this.AddLog("StoreCourse");

this.$api.SetScore("CollectionScore")
.then((data) => {
if(data.data.Status == 1){

}
})

}else{
if(data.data.Data == "已收藏"){
alert("已在收藏中")
}
}

})
}
}
}

}

},

AddLog:function(type){
var ChapterID = this.GLOBAL.ChapterID;
var IDCode = this.GLOBAL.IDCode;

if(type == "StoreCourse"){
this.$api.GetCourse([IDCode])
.then((data) =>{
if(data.data.Status == 0){
this.$tyh.AddLog(IDCode,data.data.Data[0].Name,type)
.then((data) => {
if (data.data.Status == 0) {

}
});
}

})

}else if(type == "StoreVideo"){
this.$tyh.GetByChapterID(ChapterID)
.then((data) => {
this.$tyh.AddLog(IDCode+"/"+ChapterID,data.data.Data.resource.Name,type)
.then((data) => {
if (data.data.Status == 0) {

}
});

})



}



}
}
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Collection.vue